export default __webpack_public_path__ + "static/media/footerbg.7d529b87.png";